import { Analytics as AnalyticsLibrary } from '@carvana/core-analytics';
import { isMyCarsReskinFixed } from '@utils/myCarsReskinExperiment';
import { Analytics as AnalyticsConst } from '../constants';

export const Analytics = new AnalyticsLibrary({
  environment: (process.env.NODE_ENV as string) || 'development',
  project: AnalyticsConst.PROJECT_NAME,
  track: AnalyticsConst.TEAM_NAME,
  isLocalInstance: process.env.LOCAL === 'true',
});

Analytics.setGlobalCustomAttributes({
  controlFixed: isMyCarsReskinFixed(),
});
